<template>
  <div class="service">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/services">Services</router-link>
      <router-link :to="`/services/${activeService.id}`"><Icon icon="computer" />{{ activeService.title }}</router-link>
    </Breadcrumb>
    <div class="wrapper margin-top--50">
      <div class="headline-link">
        <div class="headline-link__headline">
          <Icon icon="onlineForm" color="detailed" class="hide-mobile"/>
          <Headline subline="Online-Service" :headline="activeService.title" />
        </div>
      </div>
    </div>

    <div class="sections wrapper margin-bottom--90">
      <div class="section section--main">
        <router-link to="/services/100/section-1" class="section__top">
          <div v-if="!isDone" class="donut" title="Bearbeitungsstatus">
            <img src="../../assets/images/donut5.svg" alt="Fortschritt">
            <p>64%</p>
          </div>
          <div v-else class="donut" title="Antrag vollständig">
            <img src="../../assets/images/donutFull.svg" alt="Fortschritt">
            <img class="done" src="../../assets/images/icons/check--blue.svg">
          </div>
          <div class="text">
            <h2 class="margin-bottom--10">Guten Tag, {{ headline }}</h2>
            <p>Dies ist der Online-Service "{{ activeService.title }}"</p>
            <p v-if="!isDone">Ihr Antrag ist aktuell zu <span>64%</span> vollständig.</p>
            <p v-else>Ihr Antrag vom <span>08.02.2019</span> wird aktuell geprüft und anschließend bearbeitet.</p>
          </div>
          <p v-if="!isDone" class="link">Antrag<br>stellen</p>
          <p v-else class="link">Antrag<br>bearbeiten</p>
          <Icon icon="arrowRight" class="arrow hide-mobile"/>
        </router-link>
        <div v-show="isDone" class="section__bottom">
          <h3>Aktueller Status Ihres Antrags</h3>
          <img src="../../assets/images/progress.svg" alt="Bearbeitungsstand">
        </div>
      </div>
      <h3 v-if="activeService.sections.length > 0" class="margin-bottom--10">Abschnitte dieses Online-Services ({{ activeService.sections.length }})</h3>
      <h3 v-else class="margin-bottom--10">Abschnitte dieses Online-Services</h3>
      <div class="greenline margin-bottom--30"></div>
      <div v-if="activeService.sections.length > 0" v-for="(section, index) in activeService.sections" :key="section.name" class="section" title="Abschnitt öffnen">
        <router-link :to="`/services/${activeService.id}/section-${index+1}`" class="section__top">
          <Icon :icon="section.icon" color="detailed" />
          <div class="text">
            <h5>Abschnitt {{index+1}}</h5>
            <h3 class="margin-bottom--10">{{section.name}}</h3>
            <p>{{ section.description }}</p>
          </div>
          <div v-if="!isDone" class="donut" title="Bereits ausgefüllte Formular-Gruppen">
            <img src="../../assets/images/donut5.svg" alt="Fortschritt">
            <p><b>4 </b>/ {{ section.fields }}</p>
          </div>
          <div v-else class="donut" title="Antrag vollständig">
            <img src="../../assets/images/donutFull.svg" alt="Fortschritt">
            <img class="done" src="../../assets/images/icons/check--blue.svg">
          </div>
          <Icon icon="arrowRight" class="arrow hide-mobile"/>
        </router-link>
      </div>
      <div v-if="activeService.sections.length < 1" class="section" title="Abschnitt öffnen">
        <router-link to="/services/100/section-1" class="section__top">
          <Icon icon="personalData" color="detailed" />
          <div class="text">
            <h5>Abschnitt 1</h5>
            <h3 class="margin-bottom--10">Personenbezogene Angaben</h3>
            <p>Angaben zu Ihrer Person, zum Wohnsitz, zu Versicherungen etc.</p>
          </div>
          <div v-if="!isDone" class="donut" title="Bereits ausgefüllte Formular-Gruppen">
            <img src="../../assets/images/donut5.svg" alt="Fortschritt">
            <p><b>4 </b>/ 7</p>
          </div>
          <div v-else class="donut" title="Antrag vollständig">
            <img src="../../assets/images/donutFull.svg" alt="Fortschritt">
            <img class="done" src="../../assets/images/icons/check--blue.svg">
          </div>
          <Icon icon="arrowRight" class="arrow hide-mobile"/>
        </router-link>
      </div>

    </div>

    <Teaser illu="security" columns="5" subline="Sicherheit geht vor" headline="Ihre Daten in sicheren Händen!">
      <p>Wir nehmen Datenschutz und Privatssphäre sehr ernst! Daher werden alle Angaben, Formulare und Dateien verschlüsselt an unsere Server übertragen. Das heißt sie sind geschützt vor Datendiebstähle und Missbrauch.
Ihre Daten werden ausschließlich für Zwecke der öffentlichen Verwaltung (Dienstleistungen der Behörden) verwendet und werden nicht an Dritte (außerbehördliche Einrichtungen / Unternehmen) weitergegeben.
Eine Auswertung Ihrer Dateien findet ebenfalls nicht statt. Sie können ihre Privatssphäreneinstellungen jederzeit in Ihrem Bürgerkonto ändern.</p>
      <router-link to="/" class="link margin-top--20"><Icon icon="arrowRight" color="green"/>Mehr zum Datenschutz und den Privatssphärenrichtlinien</router-link>
    </Teaser>


    <div class="wrapper margin-top--90">
      <Headline subline="Verwandte Services" headline="Das könnte Sie auch interessieren" />
      <transition-group name="list" class="row">
        <div v-for="service in suggestedServices" :key="service.id" class="list-item col-xs-12 col-sm-6 col-md-3">
          <ServiceCard :service="service"/>
        </div>
      </transition-group>
      <router-link to="/services" class="link margin-top--20"><Icon icon="arrowRight" color="green"/>Alle Services</router-link>
    </div>

    <div class="wrapper spc">
      <Headline class="margin-bottom--40 margin-top--90" subline="Kontakt" headline="Ansprechpartner" />
    </div>
    <div class="teaser">
      <div class="wrapper">
        <div class="row">
          <div class="spc__data col-xs-12 col-sm-4">
            <h6>{{ activeService.authority }}</h6>
            <p>Eichleitnerstraße 30</p>
            <p>86159 Augsburg</p>
            <h6>Kontakt</h6>
            <table>
              <tr>
                <td>Telefon:</td>
                <td><a href="tel:+49 821 598-4901">+49 821 598-4901</a></td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td><a href="mailto:augsburg@bafoeg.bayern">augsburg@bafoeg.bayern</a></td>
              </tr>
            </table>
          </div>
          <div class="spc__data col-xs-12 col-sm-4">
            <h6>Öffnungszeiten</h6>
            <table>
              <tr>
                <td>Mo, Mi, Fr:</td>
                <td>08:30 Uhr - 12:30 Uhr</td>
              </tr>
              <tr>
                <td>Do:</td>
                <td>13:00 - 16:00 Uhr</td>
              </tr>
            </table>
            <h6>Telefonische Sprechzeiten</h6>
            <table>
              <tr>
                <td>Mo, Mi, Fr:</td>
                <td>08:30 Uhr - 12:30 Uhr</td>
              </tr>
              <tr>
                <td>Do:</td>
                <td>09:00 - 12:00 Uhr</td>
              </tr>
            </table>
          </div>
          <div class="spc__img col-xs-12 col-sm-4 hide-mobile">
            <img src="../../assets/images/spc.png" alt="Ansprechpartner">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import ServiceCard from '../../components/ServiceCard/ServiceCard';

export default {
  name: 'Service',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    ServiceCard,
  },
  data() {
    return {
      suggestedServices: null,
      activeService: null,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      getServicesByIds: 'services/getServicesByIds',
      getServiceById: 'services/getServiceById',
    }),
    headline() {
      if(this.activeUser) {
        if(this.activeUser.sex == 'male') {
          return 'Herr ' + this.activeUser.lastName + '!';
        } else {
          return 'Frau ' + this.activeUser.lastName + '!';
        }
      }
      return ''
    },
    isDone() {
      if(this.activeUser) {
        return this.activeService.doneBy.includes(this.activeUser.id);
      }
    },
  },
  methods: {
  },
  created() {
    const serviceId = this.$route.params.id;
    this.activeService = this.getServiceById(serviceId);
    this.suggestedServices = this.getServicesByIds(this.activeService.relatedServices);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Service.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Service/Service.vue